<div class="project-select">
  <div>
    <a-input class="s-input" :disabled="disabled" v-model:value="valueName" placeholder="请输入项目名称" allow-clear :maxlength="100" @change="inputChange"> </a-input>
    <a-button type="primary" class="s-btn" @click="showModal">选择项目</a-button>
  </div>

  <a-modal
    v-model:visible="visible"
    :centered="true"
    :keyboard="false"
    :mask-closable="false"
    title="选择项目"
    width="1100px"
    @cancel="closeModal"
    @ok="ok"
  >
    <a-form layout="inline">
      <a-form-item label="项目名称">
        <a-input
          v-model:value.trim="queryRef.projectName"
          allow-clear
          class="w140"
          placeholder="请输入项目名称"
        ></a-input>
      </a-form-item>

      <!-- <a-form-item label="客户名称">
        <company-search-select
          v-model:value="queryRef.cooperationCompanyId"
          class="w140"
          placeholder="请输入客户名称"
        >
        </company-search-select>
      </a-form-item> -->

      <a-form-item label="项目类型">
        <project-type-select
          v-model:value="queryRef.projectTypeId"
          class="w140"
          placeholder="请选择项目类型"
        >
        </project-type-select>
      </a-form-item>
      <!-- <a-form-item label="项目负责人">
        <sales-man-select
          v-model:value="queryRef.salesmanTenantUserId"
          class="w140"
          placeholder="请选择项目负责人"
        >
        </sales-man-select>
      </a-form-item> -->

      <a-form-item>
        <a-button @click="reset" style="margin-left: 14px !important">重置</a-button>
        <a-button :loading="loading" type="primary" @click="search">查询</a-button>
      </a-form-item>
    </a-form>

    <table-wrapper
      :dataSource="dataSource"
      @onTableChange="onTableChange"
      @onRadioChange="onRadioChange"
      :pagination="pagination"
      :loading="loading"
      :columns="columns"
      :showRadiobox="true"
      :radioConfig="{checkRowKey:selectedKeys?.id}"
    >
    </table-wrapper>
  </a-modal>
</div>
